<template>
  <main id="main">   
    <router-view/>
  </main>
</template>


<script>



export default {
    name: 'App',
    components: {
        
    },

    computed: {
      
    },

    mounted:function(){


    }
}

</script>

